import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import SelfAssessmentForm from '../components/SelfAssessmentForm';

const SelfAssessment = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [latestSubmission, setLatestSubmission] = useState(null);

  useEffect(() => {
    if (!currentUser?.clinicalId) { setLoading(false); return; }
    getDocs(query(
      collection(db, 'clinicalRecords', currentUser.clinicalId, 'assessments'),
      orderBy('submittedAt', 'desc'),
      limit(1)
    ))
      .then(snap => setLatestSubmission(snap.empty ? null : snap.docs[0].data()))
      .catch(() => setLatestSubmission(null))
      .finally(() => setLoading(false));
  }, [currentUser?.clinicalId]);

  const formatDate = (ts) => {
    const d = ts?.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold" style={{ color: '#1e562d' }}>Self-Assessment</h1>
          <p className="text-sm text-gray-500 mt-2">
            A brief symptom screening to help your therapist understand how you've been doing.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          {loading ? (
            <div className="text-center py-10 text-sm text-gray-400">Loading…</div>
          ) : !currentUser?.clinicalId ? (
            <div className="text-center py-10">
              <div className="text-4xl mb-3">🧾</div>
              <p className="text-sm text-gray-500">
                Please complete your <a href="/intake" className="font-medium underline" style={{ color: '#1e562d' }}>intake form</a> before submitting a self-assessment.
              </p>
            </div>
          ) : latestSubmission ? (
            <div className="text-center py-10">
              <div className="text-4xl mb-3">✅</div>
              <h3 className="font-semibold mb-1" style={{ color: '#1e562d' }}>You've already submitted an assessment</h3>
              <p className="text-sm text-gray-500">
                Submitted on {formatDate(latestSubmission.submittedAt)} · Reviewed by your therapist
              </p>
            </div>
          ) : (
            <SelfAssessmentForm />
          )}
        </div>
      </div>
    </div>
  );
};

export default SelfAssessment;
